import { router } from 'expo-router'
import { FormattedMessage } from 'react-intl'
import { View } from 'react-native'

import { Button } from '@/src/elements/button/default'
import { Typography } from '@/src/elements/text/Typography'
import { useMeQuery } from '@/src/features/auth/services/useMeQuery'
import { EVENT_ORIGIN } from '@/src/features/community/models/community.constants'
import { SuggestedCommunitiesSection } from '@/src/features/community/ui/components/SuggestedCommunitiesSection'
import { ICON } from '@/src/general/enums/icons'
import { TRACKING_SOURCE } from '@/src/general/utils/gtm/constants'
import { useRoutes } from '@/src/general/utils/routes'
import { useTranslate } from '@/src/lang/useTranslate'

const EmptyPrayerSpace = () => {
  const { data: me } = useMeQuery()
  const { t } = useTranslate()
  const { routes } = useRoutes()

  const handlePress = () => {
    router.navigate(routes.communities())
  }

  return (
    <View className="flex-column flex w-screen items-center pb-4 pt-24 md:max-w-screen-md md:pb-0 md:pt-16">
      <Typography size="mdlc" colors="default" contrast="default" className="px-6 pb-4">
        {t('prayer-space.welcome.paragraph', { userName: me?.name })}
      </Typography>
      <View className="flex-column items-left flex w-full">
        <SuggestedCommunitiesSection
          sectionTitle={t('community.communities.suggested')}
          containerProps={{ className: 'px-4' }}
          titleProps={{ className: 'mb-4' }}
          source={TRACKING_SOURCE.PRAYER_SPACE}
          origin={EVENT_ORIGIN.COMMUNITIES_SUGGESTION}
        />
      </View>
      <View className="flex-column flex items-center gap-4 px-6">
        <Typography size="mdlc" colors="default" contrast="default">
          <FormattedMessage id="prayer-space.welcome.end-paragraph" />
        </Typography>
        <Button
          size="md"
          endIcon={ICON.CHEVRON_RIGHT}
          colors="primary"
          variant="faded"
          contrast="default"
          className="px-10"
          onPress={handlePress}
        >
          <FormattedMessage id="prayer-space.welcome.discover" />
        </Button>
      </View>
    </View>
  )
}

export default EmptyPrayerSpace
